const {hasMeaning}=require('../utils/meaningAdmission');
const normalize=word=>String(word).normalize('NFC').trim().toLocaleLowerCase('tr-TR');
function sensesFrom(value,word){
 const raw=value?.entries?.[normalize(word)];
 if(!hasMeaning(raw))return [];
 return raw.filter(s=>typeof s?.text==='string'&&s.text.trim()).map(s=>{
  if(!value.wiktionary||!s.wikiWord)return s;
  const encoded=encodeURIComponent(s.wikiWord);
  return {...s,...value.wiktionary,url:'https://tr.wiktionary.org/wiki/'+encoded,historyUrl:'https://tr.wiktionary.org/w/index.php?title='+encoded+'&action=history'};
 });
}
// Never search across retained shells: CacheStorage.match may return an older build.
async function readShellMeanings(cacheStorage=globalThis.caches,doc=globalThis.document){
 const revision=doc?.querySelector('meta[name="kelimo-shell-revision"]')?.content;
 if(!revision||!cacheStorage)return null;
 try{const cache=await cacheStorage.open('kelimo-shell-'+revision);const hit=await cache.match('/offline-meanings.json');return hit?await hit.json():null;}catch(_){return null;}
}
async function resolveLocalMeaning(word,version,policy,{read,readShell=readShellMeanings,online=()=>globalThis.navigator?.onLine!==false,fetcher=globalThis.fetch,url=x=>x,timeoutMs=8000}){
 // Read through on every request. Dictionary version alone is not a meaning revision.
 const keys=version?[policy?`dictionary:${version}:policy${policy}`:null,`dictionary:${version}`,'dictionary']:['dictionary'];
 for(const key of [...new Set(keys.filter(Boolean))]){
  try{const bundle=await read(key);const senses=sensesFrom(bundle?.meanings,word);if(senses.length)return {senses};}catch(_){}
 }
 const senses=sensesFrom(await readShell(),word);if(senses.length)return {senses};
 if(online()){
  const controller=new AbortController();let timer;
  try{
   const expired=new Promise((_,reject)=>{timer=setTimeout(()=>{controller.abort();reject(Error('timeout'));},timeoutMs);});
   const request=(async()=>{const response=await fetcher(url(`/word-meaning?word=${encodeURIComponent(word)}`),{cache:'no-store',signal:controller.signal});if(!response.ok)return null;return response.json();})();
   const result=await Promise.race([request,expired]);const found=sensesFrom({entries:{[normalize(word)]:result?.senses}},word);if(found.length)return {senses:found};
  }catch(_){}finally{clearTimeout(timer);}
 }
 return {senses:[],message:'Bu cihazda kelimenin anlam kaydı bulunamadı. İnternete bağlanıp yeniden deneyebilirsin.'};
}
module.exports={sensesFrom,readShellMeanings,resolveLocalMeaning};
